// src/contexts/EmployeeModalContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';
import EmployeeExpandedView from '../components/cards/EmployeeExpandedView';

const EmployeeModalContext = createContext({ openEmployeeModal: () => {} });

export const useEmployeeModal = () => useContext(EmployeeModalContext);

export const EmployeeModalProvider = ({ children, onAddToLayout }) => {
  const [state, setState] = useState({ open: false, employee: null, initialTab: 0 });

  const openEmployeeModal = useCallback((employee, initialTab = 0) => {
    setState({ open: true, employee, initialTab });
  }, []);

  const closeEmployeeModal = useCallback(() => {
    setState(prev => ({ ...prev, open: false }));
  }, []);

  const handleAddToLayout = useCallback(() => {
    closeEmployeeModal();
    if (onAddToLayout && state.employee) onAddToLayout(state.employee);
  }, [state.employee, onAddToLayout, closeEmployeeModal]);

  return (
    <EmployeeModalContext.Provider value={{ openEmployeeModal }}>
      {children}
      <EmployeeExpandedView
        open={state.open}
        employee={state.employee}
        initialTab={state.initialTab}
        onClose={closeEmployeeModal}
        onAddToLayout={onAddToLayout ? handleAddToLayout : undefined}
      />
    </EmployeeModalContext.Provider>
  );
};
